import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors} from '@angular/forms';
import {Router} from '@angular/router';
import {FarmUserServiceService} from '@services/farm-user-service.service';
import {FarmService} from '@services/farm.service';
import {LoaderService} from '@services/loader.service';
import {UserRoleService} from '@services/user-role.service';
import {ToastrService} from 'ngx-toastr';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-add-farm-user',
    templateUrl: './add-farm-user.component.html',
    styleUrl: './add-farm-user.component.scss'
})
export class AddFarmUserComponent implements OnInit {
    public userForm: FormGroup;
    public currentDate: string;
    public classifications: any[] = [];
    public roles: any[] = [];
    public farmlist: any[] = [];
    public chickTypes: any[] = [];
    public isAuthLoading = false;
    public isLoading$: Observable<boolean>;
    public UserDetail: any;
    public showPassword: boolean = false;
    public showConfirmPassword: boolean = false;

    private passwordMatchValidator(control: AbstractControl): ValidationErrors | null {
        if (!control.parent) {
            return null;
        }
        const password = control.parent.get('password')?.value;
        const confirmPassword = control.value;

        if (password && confirmPassword && password !== confirmPassword) {
            return { passwordMismatch: true };
        }
        return null;
    }

    constructor(
        private fb: FormBuilder,
        private toastr: ToastrService,
        private loaderService: LoaderService,
        private farmUserService: FarmUserServiceService,
        private userRoleService: UserRoleService,
        private farmService: FarmService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.UserDetail = JSON.parse(localStorage.getItem('UserDetail'));
        this.userForm = this.fb.group({
            name: ['', [Validators.required, Validators.minLength(2)]],
            phone: ['', [Validators.required, Validators.pattern(/^05\d{8}$/)]],
            employeeId: ['', Validators.required],
            roleId: ['', Validators.required],
            countryCode: [''],
            email: [
                '',
                [
                    Validators.required,
                    Validators.pattern(
                        '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$'
                    )
                ]
            ],
            password: [
                '',
                [
                    Validators.required,
                    Validators.minLength(8),
                    Validators.pattern(
                        '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[^a-zA-Z0-9]).{8,}$'
                    )
                ]
            ],
            confirmPassword: [
                '',
                [
                    Validators.required,
                    Validators.minLength(8),
                    Validators.pattern(
                        '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[^a-zA-Z0-9]).{8,}$'
                    ),
                    this.passwordMatchValidator.bind(this)
                ]
            ],

            parantUserId: this.UserDetail.id
        });

        this.userForm.get('password')?.valueChanges.subscribe(() => {
            this.userForm.get('confirmPassword')?.updateValueAndValidity({ emitEvent: false });
        });

        this.getRoleList();
        this.getFarmList(this.UserDetail.id);
    }

    onCountryChange(code: any) {
        console.log(code.code);
        this.userForm.patchValue({countryCode: code.code});
    }
    getRoleList() {
        this.userRoleService.getRoleList().subscribe((result) => {
            // console.log(result);
            this.roles = result;
        });
    }
    getFarmList(userId: number): void {
        this.farmService.getFarmList(userId).subscribe({
            next: (result) => {
                this.farmlist = result;
            },
            error: () => {
                this.farmlist = [];
            }
        });
    }
    onSubmit(): void {
        this.loaderService.showLoader();
        this.isAuthLoading = true;
        if (this.userForm.valid) {
            // const userdata = this.userForm.value;
            const userdata = {
                ...this.userForm.value,
                phone: String(this.userForm.value.phone)
            }; // Ensure phone is string
            console.log(userdata);
            this.farmUserService.addFarmUser(userdata).subscribe({
                next: (response) => {
                    setTimeout(() => {
                        this.isAuthLoading = false;
                        this.loaderService.hideLoader();
                        this.toastr.success('User Added Successfully');
                        this.userForm.reset;
                    }, 2000);
                    this.router.navigate(['/farm-user-list']);
                },
                error: (error) => {
                    console.log(error);
                    setTimeout(() => {
                        this.isAuthLoading = false;
                        this.loaderService.hideLoader();
                        // Handle login error
                        this.toastr.error(error.error);
                    }, 2000);
                }
            });
        } else {
            this.loaderService.hideLoader();
            this.userForm.markAllAsTouched();
            this.isAuthLoading = false;
            this.toastr.error('Please fill the required fields');
        }
    }

    get f() {
        return this.userForm.controls;
    }

    onClose(): void {
        this.router.navigate(['/farm-user-list']);
    }

    togglePasswordVisibility(): void {
        this.showPassword = !this.showPassword;
    }

    toggleConfirmPasswordVisibility(): void {
        this.showConfirmPassword = !this.showConfirmPassword;
    }
}
